import type { GroupBy } from '../../lib/boardGrouping';

const OPTIONS: { value: GroupBy; label: string }[] = [
  { value: 'status', label: 'Status' },
  { value: 'project', label: 'Project' },
  { value: 'priority', label: 'Priority' },
  { value: 'assignee', label: 'Assignee' },
  { value: 'due', label: 'Due date' },
];

export function GroupBySelect({ value, onChange }: { value: GroupBy; onChange: (g: GroupBy) => void }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-[11px] uppercase tracking-wide text-text-muted font-semibold">Group by</span>
      <select value={value} onChange={e => onChange(e.target.value as GroupBy)}
        className="px-2.5 py-1.5 bg-bg-input border border-border rounded-md text-sm text-text-primary">
        {OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}
